// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BottomNavigation_wrapper__2QDgE","slotWrapper":"BottomNavigation_slotWrapper__2h8X4","slot":"BottomNavigation_slot__3wE5W","link":"BottomNavigation_link__2lswN"};